namespace $ {
	export class $shm_hitalama_map_widget_presets extends $mol_object {

		@ $mol_action
		static for_map( map: $shm_hitalama_map ) {
			return $shm_hitalama_map_widget_presets.make({map: ()=> map})
		}

		map(): $shm_hitalama_map {
			throw new Error("Not implemented")
		}

		@ $mol_action
		table( 
			pos: readonly [number, number] | readonly number[] = [0,0],
			width = 200, height = 100,
			name?: string,
		) {
			const map = this.map()
			const widget = map.widget_add( 'table', pos, width, height, name )
			widget?.table().Map(null)?.remote( map )
			return widget
		}

		@ $mol_action
		table_novirt( 
			pos: readonly [number, number] | readonly number[] = [0,0],
			width = 200, height = 100,
			name?: string,
		) {
			const map = this.map()
			const widget = map.widget_add( 'table_novirt', pos, width, height, name )
			widget?.table().Map(null)?.remote( map )
			return widget
		}

		@ $mol_action
		tabulator( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'tabulator', pos, 720, 420 )
			widget?.table().Map(null)?.remote( this.map() )
			widget?.table_head( [ 'Дата', 'Канал', 'Показы', 'Клики', 'Расход' ] )
			widget?.table_rows( [
				[ '01.01.2026', 'Поиск', 12300, 440, 18500 ],
				[ '01.01.2026', 'Соцсети', 8300, 320, 9700 ],
				[ '02.01.2026', 'Поиск', 14200, 510, 20100 ],
				[ '02.01.2026', 'Соцсети', 9100, 390, 11200 ],
				[ '03.01.2026', 'Поиск', 13100, 480, 19300 ],
				[ '03.01.2026', 'Соцсети', 9800, 410, 12100 ],
			] )
			return widget
		}

		@ $mol_action
		text(
			pos: readonly [number, number] | readonly number[] = [0,0],
			text = 'text',
			width = 200, height = 100,
		) {
			const map = this.map()
			const widget = map.widget_add( 'text', pos, width, height )
			widget?.text( text )
			widget?.Font_size(null)?.val( map.Last_font_size()?.val() )
			widget?.Color(null)?.val( map.Last_color()?.val() )
			return widget
		}

		@ $mol_action
		file( 
			pos: readonly [number, number] | readonly number[] = [0,0],
			file: File,
			width = 350, height = 200,
		) {
			const map = this.map()
			const map_file = map.Files(null)?.make( map.land() )!
			map_file?.write( file )

			const widget = map.widget_add( 'file', pos, width, height )!
			widget.File(null)!.remote( map_file )
			widget.title( file.name )
			if( $shm_hitalama_map_widget_entity_app.archive( map_file ) ) widget.app()
			return widget
		}

		@ $mol_action
		drawing( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'drawing', pos, 320, 180 )
			widget?.drawing()
			return widget
		}

		@ $mol_action
		rect( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'rect', pos, 240, 140 )
			widget?.background_color( 'transparent' )
			this.border_preset( widget, '#808080', 4, 'solid' )
			return widget
		}

		@ $mol_action
		circle( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'circle', pos, 160, 160 )
			widget?.background_color( 'transparent' )
			this.border_preset( widget, '#808080', 4, 'solid' )
			return widget
		}

		@ $mol_action
		text_md( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'text_md', pos, 400, 400 )
			widget?.text( '# Text' )
			return widget
		}

		@ $mol_action
		input( pos: readonly [number, number] ) {
			const code = this.$.$mol_fetch.text(
				$shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/templates/snippets/js/input.js' )
			)
			const widget = this.code_js_with_autoview( pos, 'Input', code, 500, 320, 200, 40 )
			return widget
		}

		@ $mol_action
		iframe( pos: readonly [number, number] ) {
			const [ x, y ] = pos
			const width = 500
			const height = 700
			const widget = this.map().widget_add( 'iframe', pos, width, height )
			widget?.text( 'https://www.google.com/search?igu=1' )

			const code_widget = this.map().widget_add( 'code_html', [ x + width + 10, y ], 700, height )
			code_widget?.title( 'Code: Iframe' )
			code_widget?.Use_text_from(null)?.remote( widget )
			code_widget?.view_widget( widget )
			widget?.code_widget( code_widget )

			return widget
		}
		
		@ $mol_action
		chart( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'chart', pos )
			return widget
		}

		@ $mol_action
		echarts( pos: readonly [number, number] ) {
			const [ x, y ] = pos
			const widget = this.map().widget_add( 'echarts', pos, 650, 460 )
			const table_width = 420
			const table = this.map().widget_add( 'tabulator', [ x - table_width - 10, y ], table_width, 260 )

			table?.Data(null)?.val({ editable: true })
			table?.table().Map(null)?.remote( this.map() )
			table?.table_head( [ 'Дата', 'Продажи', 'Канал' ] )
			table?.table_rows( [
				[ '01.01.2026', 120, 'Онлайн' ],
				[ '02.01.2026', 180, 'Онлайн' ],
				[ '03.01.2026', 150, 'Онлайн' ],
				[ '04.01.2026', 220, 'Онлайн' ],
				[ '01.01.2026', 80, 'Розница' ],
				[ '02.01.2026', 110, 'Розница' ],
				[ '03.01.2026', 140, 'Розница' ],
				[ '04.01.2026', 160, 'Розница' ],
			] )

			if( table ) {
				widget?.Table(null)?.remote( table.table() )
			}

			const chart = widget?.chart()
			chart?.axis( 'Дата' )
			chart?.values_title( 'Продажи' )
			chart?.groups( [ 'Канал' ] )

			return widget
		}

		@ $mol_action
		range( pos: readonly [number, number] ) {
			const code = this.$.$mol_fetch.text(
				$shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/templates/snippets/js/range.js' )
			)
			const widget = this.code_js_with_autoview( pos, 'Range', code, 500, 320 )
			return widget
		}

		@ $mol_action
		date( pos: readonly [number, number] ) {
			const code = this.$.$mol_fetch.text(
				$shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/templates/snippets/js/date.js' )
			)
			const widget = this.code_js_with_autoview( pos, 'Date', code, 500, 320, 200, 40 )
			return widget
		}

		@ $mol_action
		select( pos: readonly [number, number] ) {
			const code = this.$.$mol_fetch.text(
				$shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/templates/snippets/js/select.js' )
			)
			const widget = this.code_js_with_autoview( pos, 'Select', code, 500, 320, 200, 40 )
			return widget
		}

		@ $mol_action
		code_js_with_autoview(
			pos: readonly [number, number],
			title: string,
			code: string,
			code_width = 600,
			code_height = 300,
			view_width = code_width,
			view_height = code_height,
		) {
			const [ x, y ] = pos
			const view_widget = this.map().widget_add( 'autoview', pos, view_width, view_height )
			view_widget?.title( title )

			const code_widget = this.map().widget_add( 'code_js', [ x + view_width + 10, y ], code_width, code_height )
			code_widget?.title( 'Code: ' + title )
			code_widget?.text( code )
			code_widget?.enabled( true )
			code_widget?.view_widget( view_widget )

			view_widget?.code_widget( code_widget )
			return view_widget
		}

		@ $mol_action
		guid_sync() {
			return $mol_guid()
		}

		@ $mol_action
		customdom_with_code(
			pos: readonly [number, number],
			title: string,
			code: string,
			width = 700,
			height = 500,
			code_type: 'code' | 'code_js' | 'code_ts' = 'code_js',
		) {
			const [ x, y ] = pos
			const widget = this.map().widget_add( 'customdom', pos, width, height )
			widget?.title( title )
			widget?.text( code )

			const code_widget = this.map().widget_add( code_type, [ x + width + 10, y ], 700, height )
			code_widget?.title( 'Code: ' + title )
			code_widget?.Use_text_from(null)?.remote( widget )
			code_widget?.view_widget( widget )
			widget?.code_widget( code_widget )

			return widget
		}

		@ $mol_action
		form( pos: readonly [number, number] ) {

			const form_pos = pos
			const form = this.map().widget_add( 'form', form_pos, 450, 780 )
			
			const table_pos = [ form_pos[0] + 460, form_pos[1]] as const
			const widget_table = this.table_novirt( table_pos, 1000, 780 )!
			widget_table.table_head( [ 'Запрос', 'Минус', 'Период', 'Страна', 'Язык', 'Соц.медиа', 'СМИ', 'Type', 'Tags', 'Category', '', '' ] )
			widget_table.table_col_types( [ 'any', 'any', 'any', 'any', 'any', 'file', 'file', 'any', 'any', 'any', 'action_edit', 'action_delete' ] )
			const rows_method = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_search_statistics_rows.js' ) )
			widget_table.Table(null)?.ensure( null )?.Rows_method(null)?.val( rows_method )

			const code_pos = [ form_pos[0], form_pos[1] + 790 ] as const
			const code = this.map().widget_add( 'code', code_pos, 1220, 680 )
			const code_str = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_table.js' ) )
				.replace( 'WIDGET_TITLE', `'${ 'Table_' + this.guid_sync() }'` )
			code?.text( code_str )

			return form
		}

		@ $mol_action
		deckgl_example( pos: readonly [number, number] ) {
			const code_str = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_deckgl_example.js' ) )
			return this.customdom_with_code( pos, 'Deck.gl', code_str, 700, 700, 'code_js' )
		}

		@ $mol_action
		echarts_example( pos: readonly [number, number] ) {
			const code_str = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_echarts_example.js' ) )
			return this.customdom_with_code( pos, 'ECharts', code_str, 700, 500, 'code_js' )
		}

		@ $mol_action
		code_css( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'code_css', pos, 600, 300 )
			const code_str = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_css_example.css' ) )
			widget?.text( code_str )
			return widget
		}

		@ $mol_action
		code_html( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'code_html', pos, 600, 300 )
			widget?.text( '<!DOCTYPE html>\n<html>\n<body>\n<h1>My First Heading</h1>\n<p>My first paragraph.</p>\n</body>\n</html>' )
			return widget
		}

		@ $mol_action
		button( pos: readonly [number, number] ) {
			const code = this.$.$mol_fetch.text(
				$shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/templates/snippets/js/button.js' )
			)
			const widget = this.code_js_with_autoview( pos, 'Button', code, 500, 320, 200, 40 )
			return widget
		}

		@ $mol_action
		code_js( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'code_js', pos, 600, 300 )
			widget?.text( 'return 1' )
			return widget
		}

		@ $mol_action
		component( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'component', pos, 600, 300 )
			widget?.text( '' )
			return widget
		}

		@ $mol_action
		component_parser( pos: readonly [number, number] ) {
			const [x, y] = pos
			
			const widget = this.map().widget_add( 'component_parser', [x+610, y], 600, 620 )
			widget?.text( '' )
			widget?.title( 'Парсер AI ответов' )
			
			// const css = this.map().widget_add( 'code_css', [x+610, y], 600, 300 )
			// css?.text( '' )
			// css?.title( 'CSS компонентов' )
			const data_method = `
				const template = this_widget.text()
				const regex = /\{\{([^}]+)\}\}/g;
				return Array.from( template.matchAll(regex), match => match[1].trim() + ' #textarea' ).join('\\n')
			`

			const form = this.map().widget_add( 'prompt', [x, y], 600, 200 )
			form?.title( 'Промпт для приложения' )
			const text = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_prompt.md' ) )
			form?.text( text )
			form?.Data_method(null)?.val( data_method )
			const custom = form?.form_custom()
			custom?.Use_for_fields(null)?.remote( form )

			const form2 = this.map().widget_add( 'prompt', [x, y+210], 600, 200 )
			form2?.title( 'Промпт для чата в котором уже есть контекст' )
			form2?.text( 'Тест: {{Описание изменений}}' )
			form2?.Data_method(null)?.val( data_method )
			const custom2 = form2?.form_custom()
			custom2?.Use_for_fields(null)?.remote( form2 )

			const form3 = this.map().widget_add( 'prompt', [x, y+420], 600, 200 )
			form3?.title( 'Промпт для чата с нуля' )
			form3?.text( 'Тест: {{Описание изменений}}' )
			form3?.Data_method(null)?.val( data_method )
			const custom3 = form3?.form_custom()
			custom3?.Use_for_fields(null)?.remote( form3 )

			return widget
		}

		@ $mol_action
		prompt( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'prompt', pos, 600, 200 )
			widget?.title( 'Промпт' )
			widget?.text( 'Описание: {{Описание}}\nТон: {{Тон}}' )
			widget?.Data_method(null)?.val( `
				const template = this_widget.text()
				const regex = /\\{\\{([^}]+)\\}\\}/g
				return Array.from( template.matchAll( regex ), match => match[1].trim() ).join('\\n')
			` )
			widget?.form_custom().Use_for_fields(null)?.remote( widget )
			return widget
		}

		@ $mol_action
		ai_request( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'ai_request', pos, 600, 500 )
			// widget?.title( 'AI запрос' )
			widget?.title( 'AI запрос ' + (new $mol_time_moment).toString('DD.MM.YY hh:mm') )
			return widget
		}

		@ $mol_action
		opencode_session( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'opencode_session', pos, 520, 620 )
			widget?.title( 'Агент-сессия ' + (new $mol_time_moment).toString('DD.MM.YY hh:mm') )
			return widget
		}

		@ $mol_action
		tsx( pos: readonly [number, number] ) {
			const [ x, y ] = pos
			const width = 700
			const height = 500
			const code = "const name = 'World'\nreturn (\n<div>\n  <h1>Hello, {name}!</h1>\n</div>\n)"

			const code_widget = this.map().widget_add( 'code_ts', pos, width, height )
			code_widget?.title( 'Code: tsx' )
			code_widget?.text( code )

			const view_widget = this.map().widget_add( 'autoview', [ x + width + 10, y ], width, height )
			view_widget?.title( 'View: tsx' )
			view_widget?.code_widget( code_widget )
			code_widget?.view_widget( view_widget )

			return code_widget
		}

		@ $mol_action
		code_sql( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'code_sql', pos, 600, 300 )
			widget?.text( 'return to_table( result )' )
			widget?.code_sql().sql( 'SELECT version();' )
			return widget
		}

		@ $mol_action
		layout_vert( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'layout_vert', pos, 600, 700 )
			this.border_preset( widget, 'var(--mol_theme_line)', 2, 'dashed' )
			return widget
		}

		@ $mol_action
		layout_hor( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'layout_hor', pos, 700, 300 )
			this.border_preset( widget, 'var(--mol_theme_line)', 2, 'dashed' )
			return widget
		}

		@ $mol_action
		group( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'group', pos, 600, 700 )
			return widget
		}

		@ $mol_action
		notebook( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'notebook', pos, 600, 700 )
			widget?.widgets([])
			// const widget_sql = this.map().widget_add( 'code_sql', pos, 600, 300 )!
			// widget_sql?.text( 'return to_table( result )' )
			// widget_sql?.code_sql().sql( 'SELECT * FROM pg_views' )
			// this.map().Widgets(null)?.cut( widget_sql?.link()! )
			// widget?.widgets( [widget_sql] )
			return widget
		}

		@ $mol_action
		notebook2( pos: readonly [number, number] ) {
			const widget = this.map().widget_add( 'notebook2', pos, 600, 700 )
			this.border_preset( widget, 'var(--mol_theme_line)', 2, 'dashed' )
			widget!.auto_height( true )
			widget?.widgets([])
			return widget
		}

		@ $mol_action
		get_custom_guid() {
			return $mol_guid(12).replace(/[0-9]/g, '').toLowerCase()
		}
		
		@ $mol_action
		customizer( pos: readonly [number, number] ) {

			const map = this.map()
			const widget = map.widget_add( 'customizer', pos, 1200, 600 )
			const custom = map.Customs(null)?.make( null )

			widget?.Custom(null)?.remote( custom )

			
			const type_custom = 'widget_ba_messagecount_' + this.get_custom_guid()
			custom?.title( 'BA messagecount' )
			// custom?.title( type_custom )
			
			const code_js = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_widget_ba_messagecount.js' ) )
				.replaceAll( 'widget_ba_messagecount', type_custom )
			custom?.Code_js(null)?.value( code_js )

			const code_view_tree = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_widget_ba_messagecount.view.tree' ) )
				.replace( 'widget_ba_messagecount', type_custom )

			custom?.Code_view_tree(null)?.value( code_view_tree )

			const code_css = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_widget_ba_messagecount.view.css' ) )
				.replaceAll( 'widget_ba_messagecount', type_custom )
			custom?.Code_css(null)?.value( code_css )

			return custom
		}

		@ $mol_action
		form_custom( pos: readonly [number, number] ) {
			
			const [x, y] = pos
			const field_names = [ 'Запрос', 'Дата #date', 'Период #period', 'Файл #file'] 
			const code = this.map().widget_add( 'code', [x-310, y], 300, 400 )
			code?.text( field_names.join('\n') )

			const form = this.map().widget_add( 'form_custom', [x, y], 300, 600 )
			const custom = form?.form_custom()
			custom?.Use_for_fields(null)?.remote( code )
			
			const widget_table = this.map().widget_add( 'table', [x+310, y], 1000, 780 )!
			const table = widget_table.Table(null)?.ensure( null )
			table?.Form_custom(null)?.remote( custom )
			
			return form
		}

		@ $mol_action
		tg_ext( pos: readonly [number, number] ) {
			
			const [x, y] = pos
			const field_names = [ 'id' ] 
			const code = this.map().widget_add( 'code', [x-310, y], 300, 200 )
			code?.text( field_names.join('\n') )

			const form = this.map().widget_add( 'chrome_telegram', [x, y], 300, 200 )
			const custom = form?.form_custom()
			custom?.Use_for_fields(null)?.remote( code )
			form?.form_custom().hide_buttons( true )
			
			return form
		}

		@ $mol_action
		viewport_frame( pos: readonly [number, number] ) {
			
			const [x, y] = pos

			const height = this.map().Last_height()?.val() ?? 1080
			const width = this.map().Last_width()?.val() ?? 1920

			const widget = this.map().widget_add( 'viewport_frame', [x, y], width, height )
			this.border_preset( widget, 'var(--mol_theme_line)', 2, 'dashed' )

			const num = this.map().viewport_frames().length
			widget?.text( num.toString() )

			const order = this.map().Widgets_list()?.remote_list().length!-1
			this.map().Widgets_list(null)?.move( order, 0 )
			// this.Map_page().viewport_frames_visible( true )
			
			return widget
		}

		border_preset(
			widget: $shm_hitalama_map_widget | null | undefined,
			color: string,
			width: number,
			style: string,
		) {
			widget?.Border_color(null)?.val( color )
			widget?.Border_width(null)?.val( width )
			widget?.Border_style(null)?.val( style )
		}

		@ $mol_action
		tokens( pos: readonly [number, number] ) {
			
			const [x, y] = pos
			const widget = this.map().widget_add( 'tokens', [x, y], 450, 100 )
			
			return widget
		}

		@ $mol_action
		posts( pos: readonly [number, number] ) {
			
			const [x, y] = pos
			const widget = this.map().widget_add( 'posts', [x, y], 500, 600 )

			const code = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_posts_code.js' ) )
			// widget?.text( 'return []' )
			widget?.text( code )
			
			return widget
		}

		@ $mol_action
		secrets( pos: readonly [number, number] ) {

			const [x, y] = pos

			const secrets: any = $shm_hitalama_profile.current()?.secrets()
			const keys = [ 'backup_bot_token', 'backup_chat_id', 'token_ba' ]
			for (const key in secrets) {
				if( secrets[key] && !keys.includes(key) ) keys.push( key )
			}

			const field_names = keys
			const text = this.text( [x-200, y], field_names.join('\n'), 200, 300 )

			const form = this.map().widget_add( 'form_custom', [x, y], 300, 600 )
			form?.form_custom().hide_buttons( true )
			form?.Data_method(null)?.val(`
				return $`+`shm_hitalama_profile.current()?.secrets($`+`next)
			`)

			const custom = form?.form_custom()
			custom?.Use_for_fields(null)?.remote( text )
			
			return form
		}

		// customs() {
		// 	const visible = this.map().Customs()?.remote_list().filter( c => c.Visible_in_contextmenu()?.val() )
		// 	return visible?.map( c => this.Custom_add( c.link() ) ) ?? []
		// }

		// custom_add_title( ref: $giper_baza_link ) {
		// 	const custom = $giper_baza_glob.Pawn( ref, $shm_hitalama_map_widget_entity_custom )
		// 	return super.custom_add_title(0).replace( '{title}', custom.title() )
		// }

		// custom_add( ref: $giper_baza_link ) {
		// 	const custom = $giper_baza_glob.Pawn( ref, $shm_hitalama_map_widget_entity_custom )

		// 	const widget = this.map().widget_add( 'custom', pos )
		// 	widget?.Type_custom(null)?.remote( custom )

		// }
		
	}

}
